export enum UebersichtFilterType {
    SAISONS = 0,
    QUARTALE = 1
}

